import {
  RelatedItemsCategoriesModel,
  RelatedItemsModel,
} from "../../../../shared/models";
import React from "react";
import { Table } from "react-bootstrap";
import { ItemVariantGridWrapper } from "../ItemDetailPageMain.styled";
import RelatedIcon from "../../../../../../../images/sidebar/item-details-logo.svg";
import ProductIcon from "../../../../../../../images/common/product.svg";
import DollarBundles from "../../../../../../../images/common/dollar-bundles.svg";
import EventIcon from "../../../../../../../images/common/event-blue.svg";
import BallTrioIcon from "../../../../../../../images/common/ball-trio.svg";
import AddMultipleIcon from "../../../../../../../images/common/multiple-voilet-blue.svg";
import ItemIcon from "../../../../../../../images/placeholders/item-muted-grey.svg";
import {
  CustomButton,
  CustomLabel,
  FlexContainer,
  TableData,
  TableHead,
  TableRow,
  TBody,
  THead,
} from "@mindmemobile/mm-shared-global";
import { PropertyButtons } from "../../../../shared/styles";
import {
  CustomPlaceholders,
  PlaceholderSmallerGrid,
} from "../../../../shared/components";
import { AuthService } from "../../../../shared/services";
// import { AuthService } from "../../../../shared/services";
// import { AuthService } from "../../../../shared/services";
// import WaterBottle from '../../../../../../../../images/common/water-bottle.svg';
// import DemoImage from '../../../../../../../../images/common/demo-image-4.svg';
// import DemoImage1 from '../../../../../../../../images/common/demo-image-2.svg';

type IProps = {
  includedItems?: RelatedItemsModel[];
  requiredItems?: RelatedItemsModel;
  recommendedItems?: RelatedItemsModel;
};

type Data = {
  type: string;
  data: RelatedItemsModel;
  color?: string;
  bgColor?: string;
};

export default class ItemRelatedGrid extends React.Component<IProps> {
  get data(): Data[] {
    const list: Data[] = [];

    if (this.props.includedItems) {
      this.props.includedItems.forEach((element) => {
        list.push({ type: "Included", data: element });
      });
    }
    if (this.props.requiredItems) {
      list.push({
        type: "Required",
        data: this.props.requiredItems,
        color: "#FF9800",
        bgColor: "#FFF2DF",
      });
    }
    if (this.props.recommendedItems) {
      list.push({
        type: "Recommended",
        data: this.props.recommendedItems,
        color: "#6A7AB5",
        bgColor: "#ECF0FF",
      });
    }

    return list;
  }

  getIcon(item: string) {
    switch (item) {
      case "Product":
        return ProductIcon;
      case "IssueCredits":
        return DollarBundles;
      case "Event":
        return EventIcon;
      case "Membership":
        return BallTrioIcon;
      case "Category":
        return AddMultipleIcon;
      default:
        return ProductIcon;
    }
  }

  renderIcon(type: string) {
    return (
      <FlexContainer
        fxLayout="column"
        spacing={10}
        alignItems="center"
        padding="5px 0px"
      >
        <img src={this.getIcon(type)} />
        {/* {item.items.map((item, idx) => {
                      return <img key={idx} src={this.getIcon(item.type)} />;
                  })} */}
      </FlexContainer>
    );
  }

  renderItems(items: RelatedItemsCategoriesModel[], data: Data) {
    return (
      <>
        {items.map((item, idx) => {
          return (
            <TableRow key={idx}>
              {this.typeColumn(data)}
              <TableData className="text-center vertical-align-top">
                {this.renderIcon(item.type)}
              </TableData>
              <TableData className="table-col-30" color="#556bb8">
                {item.name}
              </TableData>
              <TableData className="text-center related-media-column">
                <FlexContainer
                  fxLayout="column"
                  spacing={10}
                  alignItems="center"
                  padding="5px 0px"
                >
                  {item.medias?.length > 0 && (
                    <img src={item.medias[0].fullURL} />
                  )}
                </FlexContainer>
              </TableData>
              <TableData className="table-col-30">
                <CustomLabel>{item.priceDisplay}</CustomLabel>
              </TableData>
            </TableRow>
          );
        })}
      </>
    );
  }

  renderByType(data: Data) {
    if (data.data.showSelectItems) {
      return this.renderItems(data.data.items, data);
    }

    if (data.data.showAccountCredits) {
      return this.renderAccountCredits(data.data, data);
    }
    if (data.data.showCategories) {
      return this.renderCategories(data.data.categories, data);
    }
    return null;
  }

  typeColumn(data: Data) {
    return (
      <TableData className="vertical-align-top table-col-20">
        <FlexContainer fxLayout="column" spacing={10}>
          <CustomButton color={data.color} bgColor={data.bgColor}>
            {data.type}
          </CustomButton>
        </FlexContainer>
      </TableData>
    );
  }

  renderCategories(items: RelatedItemsCategoriesModel[], data: Data) {
    return (
      <TableRow>
        {this.typeColumn(data)}
        <TableData className="text-center vertical-align-top">
          {this.renderIcon("Category")}
        </TableData>
        <TableData>
          <FlexContainer fxLayout="column" spacing={10}>
            <div>
              <FlexContainer fxLayout="column">
                {items.map((item, idx) => {
                  return <CustomLabel key={idx}>{item.name}</CustomLabel>;
                })}
              </FlexContainer>
            </div>
          </FlexContainer>
        </TableData>
        <TableData className="text-center related-media-column"></TableData>
        <TableData></TableData>
      </TableRow>
    );
  }

  renderAccountCredits(item: RelatedItemsModel, data: Data) {
    return (
      <TableRow>
        {this.typeColumn(data)}
        <TableData className="text-center vertical-align-top">
          {this.renderIcon("IssueCredits")}
        </TableData>
        <TableData>Account Credits</TableData>
        <TableData className="text-center related-media-column"></TableData>
        <TableData></TableData>
      </TableRow>
    );
  }

  get totalItems() {
    let total = 0;
    this.data.forEach((item) => {
      if (item.data.showSelectItems) {
        total += item.data.items.length;
      } else {
        total += 1;
      }
    });
    return total;
  }

  render() {
    return this.totalItems > 0 ? (
      <ItemVariantGridWrapper>
        <>
          <CustomLabel fontSize="20px" fontWeight="600" margin="0px 0px 10px">
            <img src={RelatedIcon} className="variant-grid-icon" />
            Related Items
            <span className="orange-semi-bold">{this.totalItems}</span>
          </CustomLabel>

          <Table
            cellSpacing="20"
            className="table variant-table no-border-last-child"
          >
            <THead>
              <TableHead className="table-col-20">Status</TableHead>
              <TableHead className="text-center">Type</TableHead>
              <TableHead className="table-col-30">Name</TableHead>
              <TableHead className="text-center">Media</TableHead>
              <TableHead className="table-col-10">Price</TableHead>
            </THead>
            {this.data.length > 0 ? (
              <TBody
                fromPaymentSystem={AuthService.fromPaymentSystem}
                height="auto"
              >
                {this.data.map((item) => (
                  <>{this.renderByType(item)}</>
                ))}
              </TBody>
            ) : (
              <CustomPlaceholders
                image={ItemIcon}
                label={"No Related Items"}
                description={
                  <>
                    Create some Items to sell. Each one is a bit different.
                    <br />
                    Hover over each type below to learn more.
                  </>
                }
                showItems={false}
              />
            )}
          </Table>
        </>
      </ItemVariantGridWrapper>
    ) : (
      <PlaceholderSmallerGrid
        title="No Related Items"
        icon={RelatedIcon}
        buttonCaption="New"
        disableButton={true}
        buttonClick={() => {}}
      />
    );
  }
}
